import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IZone } from 'src/app/modules/map/interfaces';
import { IFront } from 'src/app/modules/widget/interfaces/front';
import { IFilter } from '../../../interfaces/filter-config';
import { FilterHandlerService } from '../../../services/filter/filter-handler.service';
import { GoogleAnalyticsService } from '../../../services/google/google-analytics.service';

@Component({
  selector: 'filter-zone',
  templateUrl: './filter-zone.component.html',
  styleUrls: ['./filter-zone.component.scss'],
})
export class FilterZoneComponent implements OnInit, AfterViewInit {
  @Input() public filter: IFilter;

  @Output() public zonesChanged: EventEmitter<IZone[]>;

  @Output() public frontLoad: EventEmitter<IFront[]>;

  public zones: any[];

  public selectedOption: any[];

  constructor(private filterHandlerService: FilterHandlerService, private googleAnalyticsService: GoogleAnalyticsService) {
    this.zones = [];
    this.selectedOption = [];
    this.zonesChanged = new EventEmitter<IZone[]>();
    this.frontLoad = new EventEmitter<IFront[]>();
  }

  /**
   * Init app
   */
  public ngOnInit(): void {
    if (this.filter.uniqueSelection) {
      this.zones = [this.filter.uniqueSelection];
      this.selectedOption = this.filter.uniqueSelection.zoneId;
      this.changeSelectedOption(this.filter.uniqueSelection);
    } else {
      this.filterHandlerService.getFronts().then((fronts: IFront[]) => {
        this.frontLoad.emit(fronts);

        // Fill distinct zones
        const zones = [];
        for (const front of fronts) {
          const found = zones.find((v) => v.zoneId === front.zoneId && v.zoneName === front.zoneName);
          if (!found) {
            if (this.filter.multiselect) {
              zones.push({
                zoneId: front.zoneId,
                zoneName: front.zoneName,
                selectedAllGroup: 'selectedAllGroup',
              });
            } else {
              zones.push({
                zoneId: front.zoneId,
                zoneName: front.zoneName,
              });
            }
          }
        }

        this.zones = zones;
      });
    }
  }

  /**
   * Component after view init
   */
  public ngAfterViewInit(): void {
    this.filterHandlerService.clearFilter$.subscribe(() => {
      if (!this.filter.uniqueSelection) {
        this.selectedOption = [];
        this.changeSelectedOption([]);
      }
    });
  }

  /**
   * Function to emit the selected option changed
   *
   * @param $event Selected option
   */
  public changeSelectedOption($event: IZone[]): void {
    this.zonesChanged.emit($event);
    const filter = {
      filter_selected: 'filter_zone',
      value_selected: $event,
    };
    this.googleAnalyticsService.sendFilterEvent(filter);
  }
}
